import Base from '../Base';
import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Spinner, Card, Container, CardBody, CardHeader, Row, Breadcrumb, Col } from 'react-bootstrap';
import instance from "../../services/baseService";
import { toast } from "react-hot-toast";
import { ROUTES } from "../../constants/roles";
import DragDropFlowChart from './DragDropFlowChart';
import { NavLink } from 'react-router-dom';
import Loader from '../common/Loader';
import OnboardHierarchies from './OnboardHierarchies';
import { extractErrorMessage } from '../../constants/common';

const ManageRoles = () => {
    const [key, setKey] = useState("hierarchy");
    const [hierarchies, setHierarchies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        LoadFlowchartData();
    }, []);

    const handleTabChange = async (k) => {
        setKey(k);
        // Call your API when hierarchy tab is selected
        if (k === 'hierarchy') {
            await LoadFlowchartData();
        }
    };

    const LoadFlowchartData = async () => {
        await fetchRoles();
        await fetchHierarchies();
    }

    const fetchHierarchies = async () => {
        setLoading(true);
        try {
            const res = await instance.get(ROUTES.RBAC_HIERARCHY_LIST); // update with correct endpoint
            setHierarchies(res.data?.data || []);
        } catch (err) {
            console.error('Error fetching hierarchies:', err);
            const errorMessage = extractErrorMessage(err);
            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const fetchRoles = async () => {
        setLoading(true);
        try {
            const res = await instance.get(ROUTES.RBAC_GET_HIERARCHY_OPTIONS); // update with correct endpoint
            setRoles(res.data?.data?.available_roles);
        } catch (err) {
            console.error('Error fetching roles:', err);
            const errorMessage = extractErrorMessage(err);
            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const onAddNode = async ({ id }) => {
        try {
            const addNodePromise = instance.post(ROUTES.RBAC_ADD_HIERARCHY_OPTIONS, {
                parent_role_id: null,
                role_id: id,
            });
            return addNodePromise;
        } catch (err) {
            const errorMessage = extractErrorMessage(err);
            toast.error(errorMessage || 'Error adding node');
        }
    }

    const onAddEdge = async ({ source, target }) => {
        try {
            const addEdgePromise = instance.post(ROUTES.RBAC_UPDATE_HIERARCHY_OPTION(target), {
                parent_role_id: source,
            });
            return addEdgePromise;
        } catch (err) {
            const errorMessage = extractErrorMessage(err);
            toast.error(errorMessage || 'Error adding edge');
        }
    }

    const onDeleteNode = async ({ id }) => {
        try {
            const deleteNodePromise = instance.get(ROUTES.RBAC_REMOVE_HIERARCHY_OPTION(id));
            return deleteNodePromise;
        } catch (err) {
            const errorMessage = extractErrorMessage(err);
            toast.error(errorMessage || 'Error deleting edge');
        }
    }

    return (
        <Base>
            <Container>
                <Row>
                    <Col className="mr-auto text-center">
                        <Breadcrumb>
                            <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: '/' }}>Dashboard</Breadcrumb.Item>
                            <Breadcrumb.Item active>Manage Hierarchy</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>
                <div className="flex justify-between items-center ">
                    <h1 className="text-[28px] font-bold text-gray-800">Manage Hierarchy</h1>
                </div>
                <Tabs activeKey={key} onSelect={handleTabChange} className="mb-3 border-bottom" variant="underline" style={{ "--bs-nav-underline-link-active-color": "#0d6efd", }}>
                    <Tab eventKey="hierarchy" title="Company Hierarchy">
                        {loading ? (
                            <Loader />
                        ) : (
                            <DragDropFlowChart
                                data={hierarchies}
                                loadData={LoadFlowchartData}
                                dragItems={roles}
                                onAddNode={onAddNode}
                                onAddEdge={onAddEdge}
                                onDeleteNode={onDeleteNode}
                            />
                        )}
                    </Tab>
                    <Tab eventKey="useronboard" title="Other Onboard Hierarchies">
                        {loading ? (
                            <Loader />
                        ) : (
                            <OnboardHierarchies></OnboardHierarchies>
                        )}
                    </Tab>
                </Tabs>
            </Container>
        </Base>
    );
}

export default ManageRoles